import { applyMiddleware, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import storage from 'redux-persist/lib/storage';
import Reducers from '../reducers/common';
import RootSaga from '../sagas';

const sagaMiddleware = createSagaMiddleware();
/**
 * Persist config to persist(save/store) reducer
 */
const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'CommonReducer',
    'DashBoardReducer',
    'ChallengeReducer',
    //   'FlashCardReducer'
  ],
};

/**
 * Persist reducer
 */
const persistedReducer = persistReducer(persistConfig, Reducers);

/**
 * Create store with persisted reducer
 */
export const store = createStore(
  persistedReducer,
  applyMiddleware(sagaMiddleware),
);

sagaMiddleware.run(RootSaga);

export const persistor = persistStore(store);
